<template>
  <v-app>
    <v-main>
      <!-- Router View to load the current route's component -->
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { mapState } from 'vuex';
import { watch } from 'vue';

export default {
  name: 'App',
  setup() {
    const { locale } = useI18n();
    return { i18nLocale: locale };
  },
  computed: {
    ...mapState(['locale']),
  },
  watch: {
    // Watch for locale changes in Vuex store and sync with i18n
    locale: {
      handler(newLocale) {
        if (this.i18nLocale !== newLocale) {
          this.i18nLocale = newLocale;
        }
      },
      immediate: true,
    },
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
